import React from "react";

export const Logo = ({ value }) => {
  if (!value) return null;

  return (
    <div className="d-flex justify-content-end">
      <img
        alt="Logo"
        src={value}
        style={{ maxWidth: "100%", maxHeight: "150px" }}
      />
    </div>
  );
};

export default Logo;
